<script lang="ts">
	import { TermsGenerator } from '#lib/features/terms/components/TermsGenerator/index.js';
	import { page } from '$app/state';
	import type { EditionsTermsPageData } from '$routes/editions/terms/types';

	const terms = page.data.terms as EditionsTermsPageData['terms'];
	const title = page.data.title as EditionsTermsPageData['title'];
</script>

<TermsGenerator dataCy="editions-terms" {terms} {title} />
